<!-- <div class="hero-banner-container">
    <div class="content">
        <span class="title">{{title}}</span>        
    </div>    
    <div class="lines">
        <div class="small-band"></div> 
        <div class="large-band"></div>
    </div>
</div> -->


<div class="nsw-hero-banner nsw-hero-banner--dark nsw-hero-banner--wide nsw-hero-banner--lines">
	<div class="nsw-hero-banner__container">
		<div class="nsw-hero-banner__wrapper">
			<div class="nsw-hero-banner__content">
				<h1>{{title}}</h1>
				<!-- <p class="nsw-intro">Find the building blocks for creating user-centred digital services, as well as
					policy, tools and guidance</p>
				<div class="nsw-hero-banner__button">
					<a href="#" class="nsw-button nsw-button--white">
						View DigitalService Toolkit
					</a>
				</div> -->
			</div>
			<div class="nsw-hero-banner__box">
				<div class="nsw-hero-banner__lines"></div>
			</div>
		</div>
	</div>
</div>